// Environment
import { Env } from "./env.type";
import PvDev from "./pv/dev";
import PvLocal from "./pv/local";
import PvPrd from "./pv/prd";

const contexts: Array<Env> = [PvDev, PvLocal, PvPrd];

const context = (() => {
  const host = `${window.location.protocol}//${window.location.host}`;

  if (host.includes("www")) {
    window.location.href = host.replace("www.", "");
  }

  const context = contexts.find((ctx) => ctx.host === host);

  if (typeof context === "undefined") {
    throw new Error("Configuration not found, verify environment");
  }

  return context;
})();

export const { host, env, brand, api, auth, apm, nameAplication, initialsApplication } =
  context;
export default context;
